const _tableCellBaseStyle = theme => ({
  fontFamily: theme.tokens.ComponentSimpleTableFontFamily,
  fontWeight: theme.tokens.ComponentSimpleTableFontWeight
});
const _tableCellHeaderStyle = theme => ({
  '.MuiTableHead-root &': {
    borderBottomStyle: 'solid',
    borderBottomWidth: '2px'
  },
  '.interstate-white .MuiTableHead-root &': {
    color: theme.tokens.ComponentSimpleTableHeaderBgWhiteColor,
    backgroundColor: theme.tokens.ComponentSimpleTableHeaderBgWhiteBg,
    borderBottomColor: theme.tokens.ComponentSimpleTableHeaderBgWhiteBorderColor
  },
  '.interstate-light .MuiTableHead-root &': {
    color: theme.tokens.ComponentSimpleTableHeaderBgLightColor,
    backgroundColor: theme.tokens.ComponentSimpleTableHeaderBgLightBg,
    borderBottomColor: theme.tokens.ComponentSimpleTableHeaderBgLightBorderColor
  },
  '.interstate-dark .MuiTableHead-root &': {
    color: theme.tokens.ComponentSimpleTableHeaderBgDarkColor,
    backgroundColor: theme.tokens.ComponentSimpleTableHeaderBgDarkBg,
    borderBottomColor: theme.tokens.ComponentSimpleTableHeaderBgDarkBorderColor
  },
  '.interstate-large .MuiTableHead-root &': {
    padding: '12px 16px',
    fontSize: theme.tokens.ComponentSimpleTableHeaderSizeLarge
  },
  '.interstate-small .MuiTableHead-root &': {
    padding: '8px 16px',
    fontSize: theme.tokens.ComponentSimpleTableHeaderSizeSmall
  }
});
const _tableCellBodyStyle = theme => ({
  '.MuiTableBody-root &': {
    color: theme.tokens.ComponentSimpleTableBodyColor,
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    borderBottomColor: theme.tokens.ComponentSimpleTableBodyBorderColor
  },
  '.interstate-large .MuiTableBody-root &': {
    padding: '14px 16px',
    fontSize: theme.tokens.ComponentSimpleTableBodySizeLarge
  },
  '.interstate-small .MuiTableBody-root &': {
    padding: '10px 16px',
    fontSize: theme.tokens.ComponentSimpleTableBodySizeSmall
  }
});
export const tableCellDefaultStyle = theme => {
  return {
    ..._tableCellBaseStyle(theme),
    ..._tableCellHeaderStyle(theme),
    ..._tableCellBodyStyle(theme)
  };
};
export const simpleTableDefaultStyle = (theme, bordered, hover, striped) => {
  const base = {
    backgroundColor: theme.tokens.ComponentSimpleTableBg,
    borderRadius: theme.tokens.ComponentSimpleTableRadius,
    boxShadow: theme.tokens.ComponentSimpleTableBoxShadow
  };
  const borderedStyle = {
    td: {
      borderWidth: 1,
      borderColor: theme.tokens.ComponentSimpleTableBorderColor,
      borderStyle: 'solid'
    }
  };
  const hoverStyle = {
    tbody: {
      'tr:hover': {
        backgroundColor: theme.tokens.ComponentSimpleTableBodyHover
      }
    }
  };
  const stripedStyle = {
    'tr:nth-child(even)': {
      backgroundColor: theme.tokens.ComponentSimpleTableStripedBg,
      '&:hover td, &:hover th': {
        backgroundColor: theme.tokens.ComponentSimpleTableBodyHover
      }
    }
  };
  const _bordered = bordered ? borderedStyle : {};
  const _hover = hover ? hoverStyle : {};
  const _striped = striped ? stripedStyle : {};
  return {
    ...base,
    ..._bordered,
    ..._hover,
    ..._striped
  };
};